import { withInstall } from '@sgui-plus/utils/with-install'

import Input from './src/input.vue'

export const SgInput = withInstall(Input)
export default SgInput

export * from './src/input'
